export enum WeekDay {
  Monday = 1,
}
